import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";

interface CommandPaletteApi {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
}

const Ctx = createContext<CommandPaletteApi | null>(null);

export function CommandPaletteProvider({ children }: { children: ReactNode }) {
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    function onKeydown(e: KeyboardEvent) {
      const metaK = (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k";
      if (metaK) {
        e.preventDefault();
        setOpen((v) => !v);
      } else if (e.key === "Escape") {
        setOpen(false);
      }
    }
    window.addEventListener("keydown", onKeydown);
    return () => window.removeEventListener("keydown", onKeydown);
  }, []);

  const api = useMemo<CommandPaletteApi>(
    () => ({ isOpen, open: () => setOpen(true), close: () => setOpen(false), toggle: () => setOpen((v) => !v) }),
    [isOpen]
  );

  return <Ctx.Provider value={api}>{children}</Ctx.Provider>;
}

export function useCommandPalette(): CommandPaletteApi {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useCommandPalette 必须在 CommandPaletteProvider 内使用");
  return ctx;
}
